import { IBackofficeState } from '../../types/backoffice.types';
import {
  BO_GET_COMPANY_DETAILS_FAILURE,
  BO_GET_COMPANY_DETAILS_REQUEST,
  BO_GET_COMPANY_DETAILS_SUCCESS,
  BO_GET_USER_DETAILS,
  BO_GET_USER_DETAILS_FAILURE,
  BO_GET_USER_DETAILS_SUCCESS,
  GET_LAZY_LOGIN_TOKEN,
  GET_LAZY_LOGIN_TOKEN_FAILURE,
  GET_LAZY_LOGIN_TOKEN_SUCCESS,
  GET_BO_COMPANY_QUOTA_DETAILS_SUCCESS,
  GET_BO_COMPANY_QUOTA_DETAILS_FAILURE,
  GET_BO_COMPANY_MONTHLY_STATS_SUCCESS,
  GET_BO_COMPANY_MONTHLY_STATS_FAILURE,
  GET_BO_COMPANY_TEAM_MEMBERS_STATS_SUCCESS,
  GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE,
  GET_BO_LEDGER_DETAILS_SUCCESS,
  GET_BO_LEDGER_DETAILS_REQUEST,
  GET_BO_LEDGER_DETAILS_FAILURE,
} from '../../constants/ActionTypes';
import { BackofficeActions } from '../../actions/RecruiterDashboard/backoffice.actions';

const initialState: IBackofficeState = {
  quotas: null,
  monthlyStats: null,
  selectedCompany: null,
  loading: false,
  error: null,
  userData: null,
  userDataError: null,
  lazyLoginToken: null,
  isLazyLoadingInProgress: false,
  ledgerDetails: null,
  ledgerDetailsError: null,
  leadgerLoading: false,
};

const backofficeReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: BackofficeActions
): IBackofficeState => {
  switch (action.type) {
    case BO_GET_COMPANY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        selectedCompany: null,
        error: null,
      };
    case BO_GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCompany: action.payload.companyDetails,
        error: null,
      };
    case BO_GET_COMPANY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case BO_GET_USER_DETAILS:
      return {
        ...state,
        loading: true,
        userData: null,
        userDataError: null,
      };
    case BO_GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        loading: false,
        userDataError: null,
      };
    case BO_GET_USER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        userDataError: action.payload,
      };
    case GET_LAZY_LOGIN_TOKEN:
      return {
        ...state,
        isLazyLoadingInProgress: true,
        lazyLoginToken: null,
        error: null,
      };
    case GET_LAZY_LOGIN_TOKEN_SUCCESS:
      return {
        ...state,
        lazyLoginToken: action.payload,
        isLazyLoadingInProgress: false,
        error: null,
      };
    case GET_LAZY_LOGIN_TOKEN_FAILURE:
      return {
        ...state,
        isLazyLoadingInProgress: false,
        error: action.payload,
      };
    case GET_BO_COMPANY_QUOTA_DETAILS_SUCCESS:
      return {
        ...state,
        quotas: action.payload.quotaDetails,
        isLazyLoadingInProgress: false,
        error: null,
      };
    case GET_BO_COMPANY_QUOTA_DETAILS_FAILURE:
      return {
        ...state,
        quotas: null,
        isLazyLoadingInProgress: false,
        error: action.payload.error,
      };
    case GET_BO_COMPANY_MONTHLY_STATS_SUCCESS:
      return {
        ...state,
        monthlyStats: action.payload.companyMonthlyStats,
        isLazyLoadingInProgress: false,
        error: null,
      };
    case GET_BO_COMPANY_MONTHLY_STATS_FAILURE:
      return {
        ...state,
        monthlyStats: null,
        isLazyLoadingInProgress: false,
        error: action.payload.error,
      };
    case GET_BO_COMPANY_TEAM_MEMBERS_STATS_SUCCESS:
      return {
        ...state,
        teamMembersStats: action.payload.teamMembersStats,
        isLazyLoadingInProgress: false,
        error: null,
      };
    case GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE:
      return {
        ...state,
        teamMembersStats: null,
        isLazyLoadingInProgress: false,
        error: action.payload.error,
      };
    case GET_BO_LEDGER_DETAILS_REQUEST:
      return {
        ...state,
        leadgerLoading: true,
        ledgerDetailsError: null,
      };
    case GET_BO_LEDGER_DETAILS_SUCCESS:
      return {
        ...state,
        leadgerLoading: false,
        ledgerDetails: action.payload.ledgerDetails,
        ledgerDetailsError: null,
      };
    case GET_BO_LEDGER_DETAILS_FAILURE:
      return {
        ...state,
        leadgerLoading: false,
        ledgerDetailsError: action.payload.error,
      };
    default:
      return state;
  }
};

export default backofficeReducer;
